import cn from 'classnames';
import { useContext } from 'react';

import Text from 'components/common/Text';
import { BrandContext } from 'context/BrandContext';
import styles from 'styles/components/signUpFunnel/box/MillionsBanner';

const MillionsBanner = () => {
  const { brand } = useContext(BrandContext);

  return (
    <div
      className={cn(
        styles[brand],
        styles.background,
        'flex-grow-0 bp1:-mb-6',
        styles.millionsBanner
      )}
    >
      <div className="flex flex-col items-center px-6 py-12 text-center bp1:py-0">
        <Text brandStylesOverrides="h5">Over</Text>
        <Text brandStylesOverrides="text-green-100" className="h1 mb-2">
          7 million
        </Text>
        <Text brandStylesOverrides="h5">boxes delivered in 2025!</Text>
      </div>
    </div>
  );
};

export default MillionsBanner;
